module.exports = __webpack_public_path__ + "img/gold_framed_symbols.93cb1363.png";